import { Card } from "react-bootstrap";
import Api from "../../../api";
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import config from '../../../config/domainconfig.json';

function TMFooter() {
  const api = new Api();
  const env = api.getEnv();
  const sites = config.ecosystem;
  return (
    <div className="tm-footer">
      <Card.Body>
          <div className="ecosystem">
          {sites.map(site =>
            <a  className="site-link" href={`${"https://" + site + ".com"}`} target="_blank">
              <Image src={`${window.location.origin + "/sites/" + site}.svg?213`} className="brand" />
            </a>
          )}
          </div>
          <span>{env.metaInfo.copyright.replace("© 2021", "© " + new Date().getFullYear())}</span>

      </Card.Body>
    </div>
  );
}

export default TMFooter;